import { mapValues } from 'lodash';
import replaceUserVars from '../../lib/replaceUserVars';

const replaceUserVarsInPortalProp = (prop, context) => {
  if (typeof prop !== 'string') return prop;

  return replaceUserVars(prop, context);
};

const replaceUserVarsInPortals = (portals, context) =>
  portals.map((portal) => ({
    ...portal,
    props: mapValues(portal.props, (prop) => replaceUserVarsInPortalProp(prop, context)),
  }));

export default replaceUserVarsInPortals;
